import { render, staticRenderFns } from "./ReviewUpLimit.vue?vue&type=template&id=2111b6ee"
import script from "./ReviewUpLimit.vue?vue&type=script&lang=js"
export * from "./ReviewUpLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports